module.exports = __webpack_public_path__ + "img/Frame 1103hrp5.e42260ab.png";